import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../../Hyperlink';
import { getPageName } from '../../../../../utils/pageName';
import styles from '../restricted_modal.module.scss';
import { RestrictedModalLayout } from '../RestrictedModalLayout';
import {
  withLoginModal,
  WithLoginModalProps,
} from '../../../../../login/withLoginModal';
import { MaterialIcon } from '../../../../material-icon/MaterialIcon';

type Props = {
  closeModal: () => void;
  source: string;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  icon: React.ReactNode;
} & WithLoginModalProps;

export const RawPublicRestrictedModal: FC<Props> = ({
  closeModal,
  openLoginModal,
  source,
  title,
  icon,
  subtitle,
}) => {
  const sourcePage: string = getPageName();

  const openLoginCta = () => {
    closeModal();
    openLoginModal();
  };

  return (
    <RestrictedModalLayout closeModal={closeModal} source={source}>
      {icon}
      <div className={styles.title}>{title}</div>
      {!!subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      <Hyperlink
        className={classNames('button large brand', styles.startButton)}
        href={`/inscription?source=${source}&sourcePage=${sourcePage}`}
      >
        <MaterialIcon name="arrow_forward" className={styles.arrow} />
        <FormattedMessage id="components/modal/components/modal-restricted/public/PublicRestrictedModal.tsx/1" />
      </Hyperlink>
      <div className={styles.bottom}>
        <FormattedMessage id="components/modal/components/modal-restricted/public/PublicRestrictedModal.tsx/2" />
        <button
          type="button"
          className={styles.bottomLink}
          onClick={openLoginCta}
        >
          <FormattedMessage id="components/modal/components/modal-restricted/public/PublicRestrictedModal.tsx/3" />
        </button>
      </div>
    </RestrictedModalLayout>
  );
};

export const PublicRestrictedModal = withLoginModal(RawPublicRestrictedModal);
